import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, TextField, Typography } from "@mui/material";
import { IDialogProps } from "../../../../../../types/IDialogProps";
import { useState } from "react";
import LabelPrinter from "../../../../../../components/LabelPrinter";
import { GraficoVendaSaldo } from "./GraficoVendaSaldo";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { IDataDetalheGiroEstoque } from "../../../../../../types/api/estoque/relatorio-giro-estoque-detalhe";
import { TFiltroObj } from "..";
import { TStateObjFiltros, filtrarLabelTodosFiltros } from "../../../../../../helpers/filtrarLabelTodosFiltros";
import truncarString from "../../../../../../helpers/truncarString";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { IDataLojas } from "../../../../../../types/api/geral/pesquisar-lojas";
import verificarIdsValidos from "../../../../../../helpers/verificarIdsValidos";
import { extrairIds } from "../../../../../../helpers/extrairIdsArray";
import useGenericDebounce from "../../../../../../lib/useGenericDebounce";

export default function DetalheDialog({
    open,
    productId,
    handleClose,
    preFilledLoja
}: DetalheDialogProps) {

    const [loja, setLoja] = useState<TFiltroObj[]>(preFilledLoja)

    const dbcLoja = useGenericDebounce<TFiltroObj[]>(loja)

    //query
    const { data: resultDetalheGiroEstoque, isLoading: isLaodingGiroEstoque } = useQuery({
        queryKey: ["relatorio-giro-estoque-detalhe", dbcLoja, productId],
        queryFn: () => axiosClient.get("/estoque/relatorio-giro-estoque-detalhe", {
            params: {
                produto_id: productId,
                periodo_inicio: null,
                periodo_fim: null,
                ...(verificarIdsValidos(dbcLoja) ? { lojas: extrairIds(dbcLoja) } : {}),
            }
        })
    });
    const { dataDetalheGiroEstoque }: IDetalheGiroEstoque = {
        dataDetalheGiroEstoque: resultDetalheGiroEstoque?.data
    }

    const { data: lojaResult, isLoading: isLoadingLoja } = useQuery({
        queryKey: ["pesquisar-lojas-detalhe-modal"],
        queryFn: () => axiosClient.get("/pesquisar-lojas", {
            params: {
                limit: 200
            }
        })
    });
    const { dataLojas }: ILojas = {
        dataLojas: lojaResult?.data.data || []
    }
    //

    //funções manipuladoras
    const handleChange = (value: TStateObjFiltros[]) => {
        const valorFinal = value.length > 0 ? filtrarLabelTodosFiltros(value) : [{ id: null, nome: "Todas" }]

        setLoja(valorFinal);
    }
    //

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                {"Detalhe do giro de produto por loja"}
            </DialogTitle>
            <DialogContent>
                {
                    isLaodingGiroEstoque &&
                    <Box display="flex" justifyContent="center" my={3}>
                        <CircularProgress />
                    </Box>
                }

                {
                    !isLaodingGiroEstoque &&
                    <Grid container spacing={2} py={2}>
                        <Grid size={{xs: 6, md: 2}}>
                            <Typography>Código</Typography>
                            <Typography variant="h6" fontWeight="bold">{dataDetalheGiroEstoque.produto.id}</Typography>
                        </Grid>

                        <Grid size={{xs: 6, md: 5}}>
                            <Typography>Código</Typography>
                            <Typography variant="h6" fontWeight="bold">{dataDetalheGiroEstoque.produto.nome}</Typography>
                            <Typography variant="caption">{dataDetalheGiroEstoque.produto.departamento} / {dataDetalheGiroEstoque.produto.setor}</Typography>
                        </Grid>

                        <Grid size={{xs: 6, md: 5}}>
                            <Autocomplete
                                multiple
                                value={loja}
                                id="checkboxes-tags-demo"
                                disableCloseOnSelect
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                disabled={isLoadingLoja}
                                getOptionLabel={(option) => option.nome}
                                onChange={(_, v) => handleChange(v)}
                                options={[{ id: null, nome: "Todas" }, ...dataLojas.map(item => ({ id: item.id, nome: item.nome }))]}
                                renderTags={(value) => truncarString(value.map(item => item.nome).join(', '), 9)}
                                renderOption={(props, option, { selected }) => {
                                    return (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.nome}
                                        </li>
                                    )
                                }}
                                renderInput={(params) => {
                                    return (
                                        <TextField {...params} label="Loja" />
                                    )
                                }}
                            />
                            {
                                isLoadingLoja &&
                                <LinearProgress sx={{ mt: 0.2 }} />
                            }
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <Box
                                p={2.5}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                bgcolor="#eeeeeecc"
                                borderRadius={2}
                            >
                                <LabelPrinter
                                    titulo="Saldo atual"
                                    valor={dataDetalheGiroEstoque.produto.saldo.toString()}
                                />

                                <LabelPrinter
                                    titulo="Saldo médio"
                                    valor={dataDetalheGiroEstoque.produto.estoque_medio.toString()}
                                />

                                <LabelPrinter
                                    titulo="Venda média"
                                    valor={dataDetalheGiroEstoque.produto.venda_media.toString()}
                                />

                                <LabelPrinter
                                    titulo="Giro"
                                    valor={dataDetalheGiroEstoque.produto.giro?.toString() || "0"}
                                />
                            </Box>
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <GraficoVendaSaldo valores={dataDetalheGiroEstoque.periodo} />
                        </Grid>
                    </Grid>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DetalheDialogProps extends IDialogProps {
    productId: number,
    preFilledLoja:  TFiltroObj[]
}

interface IDetalheGiroEstoque {
    dataDetalheGiroEstoque: IDataDetalheGiroEstoque
}

interface ILojas {
    dataLojas: IDataLojas[]
}